import { render } from "./Notice.m.vue?vue&type=template&id=62a8a84a&scoped=true"
import script from "./Notice.m.vue?vue&type=script&lang=js"
export * from "./Notice.m.vue?vue&type=script&lang=js"

import "./Notice.m.vue?vue&type=style&index=0&id=62a8a84a&scoped=true&lang=css"

import exportComponent from "/Users/sung-hojang/git-projects/blackpay-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62a8a84a"]])

export default __exports__